import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface JobQuoteCalculatorProps {
    starterBayOptions: GenericList[];
    liftOptions: GenericList[];
    kwikstageInstalledForOptions: GenericList[];
    statusId: number;
    kwikstageItem: KwikstageItem;
    items: KwikstageCalculation[];
    typeId: number;     //cannot edit install items from the allocation screen
    editOnly: boolean;  //edit quantities for allocate screen
    canEditBays: boolean;   //edit the bays for pickups from allocation screen
    showModal: boolean;
    hideModal(): void;
    update(items: KwikstageCalculation[]): void;
    updateItem(kwikstageItem: KwikstageItem): void;
    save(): void;
}

interface KwikstageItem {
    extraHours: number;
    kwikstageInstalledFor: number;
    quoteNote: string;
}

interface KwikstageCalculation {
    id: number;
    starterBayId: number;
    liftId: number;
    bays: number;
    baysRemaining: number;
}

interface GenericList {
    id: number;
    name: string;
}

const JobQuoteCalculatorModal = (props: JobQuoteCalculatorProps) => {
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    const onChange = (e: any) => {
        var ksitem = props.kwikstageItem;
        let newItem: any = {};
        newItem = ksitem;
        newItem[e.target.name] = e.target.value;

        props.updateItem(newItem);
    }

    const onChangeNumber = (e: any) => {
        var ksitem = props.kwikstageItem;
        let newItem: any = {};
        newItem = ksitem;
        newItem[e.target.name] = e.target.value * 1;

        props.updateItem(newItem);
    }

    const onCellChange = (e: any, index: number) => {
        //update item that has changed
        var items = props.items;
        var item = items[index];
        let newItem: any = {};
        newItem = item;
        newItem[e.target.name] = e.target.value;

        if (!props.editOnly) {
            //if last row then add a new row
            var lastRow = items.length - 1
            if (index === lastRow) {
                var blankRow = addBlankRow();
                items.push(blankRow);
            }
        }

        props.update(items);
    }

    const addBlankRow = () => {
        var item: KwikstageCalculation = {
            id: 0,
            starterBayId: -1,
            liftId: -1,
            bays: 0,
            baysRemaining: 0
        };
        return item;
    }

    const hideModal = () => {
        setErrors({});
        props.hideModal();
    }

    const deleteItem = (e: any, itemIndex: number) => {
        e.preventDefault();

        var items = props.items;
        if (items.length > 1) {
            deleteJobQuoteItem(itemIndex);
        } else {
            //can't delete only line
            toast.error("Cannot delete new row");
        }
    }

    const deleteJobQuoteItem = async (itemIndex: number) => {
        var items = props.items;
        var item = items[itemIndex];
        if (item.id === 0) {
            //not saved just remove from list
            items.splice(itemIndex, 1);
            toast.success("Item removed successfully");
            props.update(items);
        } else {
            const token = await authService.getAccessToken();
            const user = await authService.getUser();

            var deleteItem = {
                id: item.id,
                subId: user.sub
            };

            axios.post('api/Job/DeleteJobQuoteItemCalculation', deleteItem, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                items.splice(itemIndex, 1);
                toast.success("Item removed successfully");
                props.update(items);
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;
        var ksItem = props.kwikstageItem;
        var items = props.items;

        if (ksItem.kwikstageInstalledFor <= 0) {
            formIsValid = false;
            errorList["kwikstageInstalledFor"] = "Installed For is required";
        }

        var errorString = "Please enter the following values: ";
        var error = false;

        var totalBays = 0;
        var itemLength = props.editOnly ? items.length : items.length - 1;
        for (var i = 0; i < itemLength; i++) {
            var newErrorString = "";

            if (!items[i].starterBayId || items[i].starterBayId <= 0) {
                newErrorString += "Starter Bay, ";
                error = true;
            }

            if (!items[i].liftId || items[i].liftId <= 0) {
                newErrorString += "Lift, ";
                error = true;
            }

            if (!items[i].bays) {
                items[i].bays = 0;
            }

            if (!props.editOnly && items[i].bays <= 0) {
                newErrorString += " Bays > 0, ";
                error = true;
            }

            //when editing, check that we don't go above the remaining bays
            if (props.editOnly && items[i].bays > items[i].baysRemaining) {
                error = true;
                newErrorString += " Bays cannot be > remaining bays, ";
            }

            totalBays += (items[i].bays * 1);

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + (i + 1) + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }

        if (props.editOnly && totalBays === 0) {
            //make sure we have total bays > 0
            error = true;
            errorString += "\n"
            errorString += "You must enter a least 1 Bay!"
        }

        if (error) {
            formIsValid = false;
            errorList["items"] = errorString;
        }
        setErrors(errorList);
        return formIsValid;
    }


    const save = (e: any) => {
        e.preventDefault();

        if (validate()) {
            props.save();
        }
    }

    const showDelete = props.statusId === 1 || props.statusId === 2;
    const isDisabled = props.statusId != 1 && props.statusId != 2;
    const isBaysDisabled = (props.statusId === 1 || props.statusId === 2 || props.statusId === 3) && props.canEditBays ? false : true;
    const lastRow = props.editOnly ? props.items.length : props.items.length - 1;
    const buttonName = props.editOnly ? "Save" : "Calculate";

    const renderDetails = (
        <Modal show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>Calculate Kwikstage Price</Modal.Title>
                <button type="button" className="close" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <label className={props.editOnly ? "hidden" : "input-group"} htmlFor="kwikstageInstalledFor">
                    <span className="label-small">Installed For</span>
                    <select className="select" id="kwikstageInstalledFor" name="kwikstageInstalledFor" value={props.kwikstageItem.kwikstageInstalledFor} onChange={(e) => onChange(e)} disabled={isDisabled}>
                        <option hidden defaultValue="-1"></option>
                        {props.kwikstageInstalledForOptions.map(ksOption =>
                            <option key={ksOption.id} value={ksOption.id}>{ksOption.name}</option>
                        )};
                    </select>
                </label>
                <span className="label errors">{errors["kwikstageInstalledFor"]}</span>

                <label className={props.editOnly ? "hidden" : "input-group"} htmlFor="extraHours">
                    <span className="label-small">Extra Hours</span>
                    <input className="input textalignright" min="0" step="1" type="number" id="extraHours" name="extraHours" value={props.kwikstageItem.extraHours} onChange={(e) => onChangeNumber(e)} disabled={isDisabled}></input>
                </label>

                <label className={props.editOnly ? "hidden" : "input-group marginTop10"} htmlFor="quoteNote">
                    <span className="label-small">Quote Note</span>
                    <input className="input" type="text" maxLength={20} id="quoteNote" name="quoteNote" value={props.kwikstageItem.quoteNote} onChange={(e) => onChange(e)}></input>
                </label>
                <p className={props.editOnly ? "hidden" : "text--small"}>* Note will appear under Item name when printing the Quote</p>
                <p className={props.editOnly && props.typeId === 2 ? "makeitred" : "hidden"}>NOTE: Only select the bays that you want removed from site. If you want bays left on site, remove them from this list.</p>

                <div className='overflowAuto'>
                    <table className='table table__small tableColours'>
                        <thead>
                            <tr>
                                <th className="hidden">Id</th>
                                <th></th>
                                <th>Starter Bay</th>
                                <th>Lift</th>
                                <th className={props.editOnly && props.typeId === 2 ? "" : "hidden" }>Remain</th>
                                <th>Bays</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.items.map((item, index) =>
                                <tr key={index}>
                                    <td className="hidden">{item.id}</td>
                                    <td className="table__text--align">{index + 1}</td>
                                    <td className="table__text--align">
                                        <select className="select table__select--size" id="starterBayId" name="starterBayId" value={item.starterBayId} onChange={(e) => onCellChange(e, index)} disabled={isDisabled}>
                                            <option hidden defaultValue="-1"></option>
                                            {props.starterBayOptions.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className="table__text--align">
                                        <select className="select table__select--size" id="liftId" name="liftId" value={item.liftId} onChange={(e) => onCellChange(e, index)} disabled={isDisabled}>
                                            <option hidden defaultValue="-1"></option>
                                            {props.liftOptions.map(item =>
                                                <option key={item.id} value={item.id}>{item.name}</option>
                                            )};
                                        </select>
                                    </td>
                                    <td className={props.editOnly && props.typeId === 2 ? "table__text--align" : "hidden"}>
                                        {item.baysRemaining }
                                    </td>
                                    <td className="table__text--align">
                                        <input type='number' id="bays" name="bays" className="input schedulenew__text-sm" value={item.bays} onChange={(e) => onCellChange(e, index)} disabled={isBaysDisabled} />
                                    </td>
                                    <td className="table__text--align">
                                        {lastRow != index && !props.editOnly && showDelete ?
                                            <div className="delete--tablecell">
                                                <a className="makeitred" href="#" onClick={(e) => deleteItem(e, index)}>
                                                    <span className="fas fa-times-circle edit--icon alignIconCenter"></span>
                                                </a>
                                            </div> : ""
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {errors["items"] ?
                        (errors["items"]).split("\n").map((item: any, key: any) => {
                            return <span className="label errors" key={key}>{item}<br /></span>
                        })
                        : ""}
                            
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className={props.statusId === 1 || props.statusId === 2 || props.statusId === 3 ? "popup-button--yes" : "hidden"} onClick={save}>{buttonName}</button>
            </Modal.Footer>
        </Modal>
    );

    let contents = props.showModal
        ? renderDetails
        : <div></div>;

    return (
        <div>
            {contents}
        </div>
    )

}

export default JobQuoteCalculatorModal;